import "../css/style.scss";
import { Common } from "./common";
var common = new Common();
common.setInitialDoc("pp");
common.langClick("pp");
